import { createQueryData } from '../helpers/createQueryData';

const { useQuery } = createQueryData({
  endPoint: 'Acceptance/desk_occupied_acceptances',
  options: { errorMessage: 'Не удалось загрузить периоды занятости стола' },
});

export const useDeskOccupiedDateRanges = ({
  params: { deskId } = {},
  options,
}) =>
  useQuery({
    params: { deskId },
    options: {
      enabled: Boolean(deskId),
      staleTime: 1000 * 60 * 5,
      ...options,
    },
  });
